.success {
  padding: 84px 0;
}

.rows {
  border-top: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.row {
  display: grid;
  grid-template-columns: minmax(220px, 30%) 1fr;
  gap: 40px;
  align-items: start;
  padding: 44px 0;
  border-bottom: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.row__fig {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.row__num {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(58px, 8.6vw, 124px);
  line-height: 0.86;
  letter-spacing: -0.045em;
  font-variant-numeric: tabular-nums;
}

.rowOne {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

.rowTwo {
  color: var(--color-primary-blue-900); /* PRIMARY_BLUE_900 */
}

.rowThree {
  color: var(--color-secondary-green-800); /* SECONDARY_GREEN_800 */
}

.row__body {
  padding-top: 8px;
}

.row__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(22px, 2.4vw, 30px);
  line-height: 1.16;
  letter-spacing: -0.015em;
  margin: 0 0 24px;
  max-width: 22ch;
}

.bulle {
  position: relative;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: var(--plume-shadow-bulle, 1px 2px 6px 0 rgba(89, 84, 78, 0.12));
  max-width: 60ch;
}

/* Tail: an ink triangle with a white one stacked just below, so the border reads as continuous. */
.bulle::before,
.bulle::after {
  content: '';
  position: absolute;
  left: 34px;
  width: 0;
  height: 0;
  border-style: solid;
}

.bulle::before {
  top: -14px;
  border-width: 0 14px 14px 14px;
  border-color: transparent transparent var(--color-primary-grey-900) transparent; /* PRIMARY_GREY_900 */
}

.bulle::after {
  top: -10px;
  border-width: 0 11px 11px 11px;
  border-color: transparent transparent var(--color-primary-grey-000) transparent;
}

/* Under the soft theme the card border is sand, so the tail must follow it. */
:global(:root:not([data-theme='contrast'])) .bulle::before {
  border-bottom-color: var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
}

.bulle p {
  font-size: 16px; /* COPY_M */
  line-height: 1.6;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
  margin: 0;
}

.rows__cta {
  padding-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

@media (max-width: 1000px) {
  .row {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .success {
    padding: 56px 0;
  }
}
